function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h795v316H0z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 -1 0 254)",
  fill: "url(#paint0_linear)",
  d: "M0 0h795v112H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 254h795v62H0z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M661 0H135v375h526V0z",
  fill: "#EBEDF0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M647.284 10.969H148.716a2.743 2.743 0 00-2.743 2.742v43.876a2.743 2.743 0 002.743 2.742h498.568a2.743 2.743 0 002.743-2.742V13.71a2.743 2.743 0 00-2.743-2.742zM490.924 69.927H148.716a2.743 2.743 0 00-2.743 2.742v211.152a2.743 2.743 0 002.743 2.742h342.208a2.744 2.744 0 002.744-2.742V72.669a2.743 2.743 0 00-2.744-2.742zM647.284 69.927H506.698a2.743 2.743 0 00-2.744 2.742v95.293a2.743 2.743 0 002.744 2.742h140.586a2.743 2.743 0 002.743-2.742V72.669a2.743 2.743 0 00-2.743-2.742zM647.284 180.302H506.698a2.742 2.742 0 00-2.744 2.742v22.623a2.743 2.743 0 002.744 2.743h140.586a2.743 2.743 0 002.743-2.743v-22.623a2.742 2.742 0 00-2.743-2.742zM647.284 216.636H506.698a2.743 2.743 0 00-2.744 2.742v129.571a2.743 2.743 0 002.744 2.742h140.586a2.743 2.743 0 002.743-2.742V219.378a2.743 2.743 0 00-2.743-2.742zM490.924 296.161H148.716a2.743 2.743 0 00-2.743 2.742v211.152a2.743 2.743 0 002.743 2.742h342.208a2.744 2.744 0 002.744-2.742V298.903a2.744 2.744 0 00-2.744-2.742z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519.728 25.366H418.231a2.743 2.743 0 00-2.743 2.742V43.19a2.743 2.743 0 002.743 2.742h101.497a2.743 2.743 0 002.743-2.742V28.108a2.743 2.743 0 00-2.743-2.742z",
  fill: "#5181B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.653 35.646h.85c.912 0 1.435.419 1.435 1.092v.009c0 .648-.561 1.092-1.406 1.092-.812 0-1.377-.372-1.452-.988l-.004-.033h-.746l.004.05c.084 1.017.959 1.665 2.206 1.665 1.214 0 2.168-.77 2.168-1.765v-.009c0-.862-.569-1.401-1.339-1.48v-.068c.67-.163 1.126-.72 1.126-1.377v-.008c0-.941-.804-1.615-1.938-1.615-1.172 0-1.946.615-2.051 1.611l-.009.08h.746l.004-.034c.075-.607.552-.962 1.28-.962.758 0 1.198.385 1.198.979v.008c0 .632-.49 1.075-1.256 1.075h-.816v.678zm5.475 2.825c.607 0 1.08-.264 1.364-.745h.068v.665h.728v-3.088c0-.937-.616-1.502-1.717-1.502-.963 0-1.649.477-1.766 1.184l-.004.025h.728l.005-.012c.116-.352.472-.553 1.013-.553.673 0 1.013.302 1.013.858v.41l-1.294.08c-1.05.063-1.645.527-1.645 1.33v.009c0 .82.649 1.339 1.507 1.339zm-.762-1.356v-.008c0-.448.301-.69.988-.733l1.206-.075v.41c0 .644-.541 1.13-1.282 1.13-.523 0-.912-.268-.912-.724zm4.333 1.276h.728v-3.908h2.193v3.908h.728v-4.51h-3.649v4.51zm5.081 0h.728l2.231-3.364h.067v3.364h.728v-4.51h-.728l-2.231 3.364h-.067V33.88h-.728v4.51zm7.04.08c1.084 0 1.691-.582 1.875-1.398l.009-.046-.72.004-.009.026c-.167.502-.552.77-1.159.77-.804 0-1.322-.666-1.322-1.704v-.008c0-1.017.51-1.67 1.322-1.67.648 0 1.05.36 1.164.804l.004.012h.724l-.004-.025c-.134-.803-.792-1.435-1.888-1.435-1.264 0-2.068.912-2.068 2.314v.008c0 1.431.808 2.348 2.072 2.348zm4.274 0c.607 0 1.08-.264 1.364-.745h.067v.665h.728v-3.088c0-.937-.615-1.502-1.716-1.502-.962 0-1.649.477-1.766 1.184l-.004.025h.728l.004-.012c.117-.352.473-.553 1.013-.553.674 0 1.013.302 1.013.858v.41l-1.293.08c-1.051.063-1.645.527-1.645 1.33v.009c0 .82.649 1.339 1.507 1.339zm-.762-1.356v-.008c0-.448.302-.69.988-.733l1.205-.075v.41c0 .644-.54 1.13-1.28 1.13-.524 0-.913-.268-.913-.724zm7.601-3.235h-3.65v.603h1.461v3.908h.728v-3.908h1.461v-.602zm1.051 4.511h1.611c1.034 0 1.696-.594 1.696-1.527v-.008c0-.934-.662-1.528-1.696-1.528h-.883V33.88h-.728v4.511zm1.611-2.46c.591 0 .967.364.967.925v.008c0 .556-.372.925-.967.925h-.883V35.93h.883zm4.667 2.54c1.084 0 1.691-.582 1.876-1.398l.008-.046-.72.004-.008.026c-.168.502-.553.77-1.16.77-.804 0-1.322-.666-1.322-1.704v-.008c0-1.017.51-1.67 1.322-1.67.649 0 1.051.36 1.164.804l.004.012h.724l-.004-.025c-.134-.803-.791-1.435-1.888-1.435-1.264 0-2.068.912-2.068 2.314v.008c0 1.431.808 2.348 2.072 2.348zm5.342-.08h.728v-4.51h-1.57c-1.034 0-1.695.564-1.695 1.49v.008c0 .615.385 1.083 1.021 1.263l-1.26 1.75h.858l1.152-1.616h.766v1.615zm-.842-2.218c-.59 0-.95-.338-.95-.811v-.009c0-.544.356-.87.95-.87h.842v1.69h-.842z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M632.197 25.366H530.7a2.743 2.743 0 00-2.743 2.742V43.19a2.743 2.743 0 002.743 2.742h101.497a2.743 2.743 0 002.743-2.742V28.108a2.743 2.743 0 00-2.743-2.742zM170.661 50.731c8.333 0 15.087-6.752 15.087-15.082 0-8.33-6.754-15.082-15.087-15.082-8.332 0-15.087 6.752-15.087 15.082 0 8.33 6.755 15.082 15.087 15.082zM388.742 22.623H193.978c-.758 0-1.372.614-1.372 1.371v10.97c0 .757.614 1.37 1.372 1.37h194.764c.757 0 1.371-.613 1.371-1.37v-10.97c0-.757-.614-1.37-1.371-1.37zM285.873 39.077h-91.895c-.758 0-1.372.614-1.372 1.37v10.97c0 .757.614 1.37 1.372 1.37h91.895c.758 0 1.372-.613 1.372-1.37v-10.97c0-.756-.614-1.37-1.372-1.37zM270.786 112.431h-91.895c-.758 0-1.372.614-1.372 1.372v8.226a1.37 1.37 0 001.372 1.371h91.895a1.37 1.37 0 001.372-1.371v-8.226c0-.758-.614-1.372-1.372-1.372zM624.653 80.896h-90.524c-.757 0-1.371.614-1.371 1.37v8.228c0 .757.614 1.37 1.371 1.37h90.524c.758 0 1.372-.613 1.372-1.37v-8.227c0-.757-.614-1.371-1.372-1.371zM586.249 189.214h-72.694c-.757 0-1.371.614-1.371 1.371v8.227c0 .757.614 1.371 1.371 1.371h72.694c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM611.623 104.205h-77.494c-.757 0-1.371.614-1.371 1.371v8.227c0 .757.614 1.371 1.371 1.371h77.494c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM608.88 126.828h-74.751c-.757 0-1.371.614-1.371 1.371v8.227c0 .757.614 1.371 1.371 1.371h74.751c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM556.074 148.766h-21.945c-.757 0-1.371.614-1.371 1.371v8.227c0 .757.614 1.371 1.371 1.371h21.945c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM207.694 80.896h-48.006c-.757 0-1.371.614-1.371 1.37v8.228c0 .757.614 1.37 1.371 1.37h48.006c.757 0 1.371-.613 1.371-1.37v-8.227c0-.757-.614-1.371-1.371-1.371zM212.494 99.406h-56.92a.686.686 0 100 1.371h56.92a.686.686 0 100-1.371zM265.3 80.896h-41.833c-.758 0-1.372.614-1.372 1.37v8.228c0 .757.614 1.37 1.372 1.37H265.3c.757 0 1.372-.613 1.372-1.37v-8.227c0-.757-.615-1.371-1.372-1.371zM473.78 132.313H178.891a1.37 1.37 0 00-1.372 1.371v8.226c0 .758.614 1.372 1.372 1.372H473.78c.757 0 1.371-.614 1.371-1.372v-8.226a1.37 1.37 0 00-1.371-1.371zM461.436 146.024H178.891c-.758 0-1.372.614-1.372 1.371v8.227c0 .757.614 1.371 1.372 1.371h282.545c.757 0 1.371-.614 1.371-1.371v-8.227c0-.757-.614-1.371-1.371-1.371zM466.236 159.735H178.891c-.758 0-1.372.614-1.372 1.371v8.227c0 .757.614 1.371 1.372 1.371h287.345c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM449.091 173.446h-270.2c-.758 0-1.372.614-1.372 1.371v8.227c0 .757.614 1.371 1.372 1.371h270.2c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM254.327 187.157h-75.436c-.758 0-1.372.614-1.372 1.371v8.227c0 .757.614 1.371 1.372 1.371h75.436c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM254.327 207.038h-75.436c-.758 0-1.372.614-1.372 1.372v8.226c0 .757.614 1.371 1.372 1.371h75.436c.758 0 1.372-.614 1.372-1.371v-8.226c0-.758-.614-1.372-1.372-1.372zM254.327 224.863h-75.436c-.758 0-1.372.614-1.372 1.371v8.227c0 .757.614 1.371 1.372 1.371h75.436c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM211.808 244.744h-32.917c-.758 0-1.372.614-1.372 1.371v8.227c0 .757.614 1.371 1.372 1.371h32.917c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM327.021 262.569h-148.13a1.37 1.37 0 00-1.372 1.371v8.226a1.37 1.37 0 001.372 1.371h148.13c.757 0 1.372-.613 1.372-1.371v-8.226c0-.758-.615-1.371-1.372-1.371zM169.975 112.431h-8.229c-.758 0-1.372.614-1.372 1.372v8.226a1.37 1.37 0 001.372 1.371h8.229a1.37 1.37 0 001.372-1.371v-8.226c0-.758-.614-1.372-1.372-1.372zM525.214 80.896h-8.23c-.757 0-1.371.614-1.371 1.37v8.228c0 .757.614 1.37 1.371 1.37h8.23c.757 0 1.371-.613 1.371-1.37v-8.227c0-.757-.614-1.371-1.371-1.371zM525.214 104.205h-8.23c-.757 0-1.371.614-1.371 1.371v8.227c0 .757.614 1.371 1.371 1.371h8.23c.757 0 1.371-.614 1.371-1.371v-8.227c0-.757-.614-1.371-1.371-1.371zM525.214 126.828h-8.23c-.757 0-1.371.614-1.371 1.371v8.227c0 .757.614 1.371 1.371 1.371h8.23c.757 0 1.371-.614 1.371-1.371v-8.227c0-.757-.614-1.371-1.371-1.371zM525.214 148.766h-8.23c-.757 0-1.371.614-1.371 1.371v8.227c0 .757.614 1.371 1.371 1.371h8.23c.757 0 1.371-.614 1.371-1.371v-8.227c0-.757-.614-1.371-1.371-1.371zM169.975 132.313h-8.229a1.37 1.37 0 00-1.372 1.371v8.226c0 .758.614 1.372 1.372 1.372h8.229c.758 0 1.372-.614 1.372-1.372v-8.226a1.37 1.37 0 00-1.372-1.371zM169.975 224.863h-8.229c-.758 0-1.372.614-1.372 1.371v8.227c0 .757.614 1.371 1.372 1.371h8.229c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM169.975 244.744h-8.229c-.758 0-1.372.614-1.372 1.371v8.227c0 .757.614 1.371 1.372 1.371h8.229c.758 0 1.372-.614 1.372-1.371v-8.227c0-.757-.614-1.371-1.372-1.371zM169.975 262.569h-8.229a1.37 1.37 0 00-1.372 1.371v8.226a1.37 1.37 0 001.372 1.371h8.229a1.37 1.37 0 001.372-1.371v-8.226a1.37 1.37 0 00-1.372-1.371z",
  fill: "#EBEDF0"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 263h795v53H0z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 -1 0 263)",
  fill: "url(#paint1_linear)",
  d: "M0 0h795v112H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 795,
  y1: 112,
  x2: 795,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.092,
  stopColor: "#fff",
  stopOpacity: 0.016
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.188,
  stopColor: "#fff",
  stopOpacity: 0.055
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.285,
  stopColor: "#fff",
  stopOpacity: 0.118
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.382,
  stopColor: "#fff",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.478,
  stopColor: "#fff",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#fff",
  stopOpacity: 0.392
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.657,
  stopColor: "#fff",
  stopOpacity: 0.502
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.739,
  stopColor: "#fff",
  stopOpacity: 0.608
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.812,
  stopColor: "#fff",
  stopOpacity: 0.71
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#fff",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.927,
  stopColor: "#fff",
  stopOpacity: 0.882
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.967,
  stopColor: "#fff",
  stopOpacity: 0.945
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.991,
  stopColor: "#fff",
  stopOpacity: 0.984
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 795,
  y1: 112,
  x2: 795,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.092,
  stopColor: "#fff",
  stopOpacity: 0.016
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.188,
  stopColor: "#fff",
  stopOpacity: 0.055
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.285,
  stopColor: "#fff",
  stopOpacity: 0.118
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.382,
  stopColor: "#fff",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.478,
  stopColor: "#fff",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#fff",
  stopOpacity: 0.392
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.657,
  stopColor: "#fff",
  stopOpacity: 0.502
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.739,
  stopColor: "#fff",
  stopOpacity: 0.608
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.812,
  stopColor: "#fff",
  stopOpacity: 0.71
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#fff",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.927,
  stopColor: "#fff",
  stopOpacity: 0.882
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.967,
  stopColor: "#fff",
  stopOpacity: 0.945
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.991,
  stopColor: "#fff",
  stopOpacity: 0.984
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h795v316H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 135,
  width: 526,
  height: 375,
  rx: 3.145,
  fill: "#fff"
})));

var SvgActionButtonPreviewDesktop = function SvgActionButtonPreviewDesktop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMax meet",
    viewBox: "135 0 526 275",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActionButtonPreviewDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/action-button-preview-desktop.7a398a7d.svg";
export { ForwardRef as ReactComponent };